import { Link } from 'gatsby'
import styled from 'styled-components'

export const Tag = styled.span`
    margin-right: 5px;
`

export const BlackLink = styled(Link)`
    color: #4a4a4a;
`